"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawerContext = exports.DrawerContext = void 0;
var react_1 = require("react");
exports.DrawerContext = (0, react_1.createContext)({
    open: true,
    variant: 'persistent',
    condensed: false,
});
var useDrawerContext = function () { return (0, react_1.useContext)(exports.DrawerContext); };
exports.useDrawerContext = useDrawerContext;
